<template>
  <div>
  <!-- <div @click.stop="hideDialog"> -->
  <!-- шапка -->
  <!-- <MobileMenu /> -->

  <section v-if="isMobile" class="otstup ">
      <div class="container_test_grid ">

        <div v-if="$store.state.status_check_filtr == true">
          <Name_level :data_load="$store.state.selectedDate_before_converded +' '+'-'+' '+ $store.state.selectedDate_after_converded"></Name_level>
        </div>
        <div v-if="$store.state.status_check_filtr == false">
          <Name_level :data_load="date_load"></Name_level>
        </div>
        
          
            
              <!-- <a class="no_decoration" href="#"> -->
                <div v-if="$store.state.year_change == 2024" class="container_button_year" id="showList" role="link">
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year_choosed', 
                          'ocruglen_left',
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_24">
                          <p class="text-white text_size_input_b_year_choused font_text_Arial_regular">2024</p>
                      </div>
                  </div>
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year', 
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_25">
                          <p class="text-white text_size_input_b_year font_text_Arial_regular">2025</p>
                      </div>
                  </div>
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year', 
                          'ocruglen_right',
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_26">
                          <p class="text-white text_size_input_b_year font_text_Arial_regular">2026</p>
                      </div>
                  </div> 
              </div>

              <div v-if="$store.state.year_change == 2025" class="container_button_year" id="showList" role="link">
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year', 
                          'ocruglen_left',
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_24">
                          <p class="text-white text_size_input_b_year font_text_Arial_regular">2024</p>
                      </div>
                  </div>
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year_choosed', 
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_25">
                          <p class="text-white text_size_input_b_year_choused font_text_Arial_regular">2025</p>
                      </div>
                  </div>
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year', 
                          'ocruglen_right',
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_26">
                          <p class="text-white text_size_input_b_year font_text_Arial_regular">2026</p>
                      </div>
                  </div> 
              </div>


              <div v-if="$store.state.year_change == 2026" class="container_button_year" id="showList" role="link">
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year', 
                          'ocruglen_left',
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_24">
                          <p class="text-white text_size_input_b_year font_text_Arial_regular">2024</p>
                      </div>
                  </div>
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year', 
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_25">
                          <p class="text-white text_size_input_b_year font_text_Arial_regular">2025</p>
                      </div>
                  </div>
                  <div class="no_decoration">
                      <div :class="[
                          'item_test_b_year', 
                          'background_inputs_b_year_choosed', 
                          'ocruglen_right',
                          { 'disabled-button': isLoading }
                      ]" @click.stop="set_26">
                          <p class="text-white text_size_input_b_year_choused font_text_Arial_regular">2026</p>
                      </div>
                  </div> 
              </div>
                
                
             

          
          
                    <!-- <p class="text-white text_size_header_text text-start font_text_ariblk">Кронштадт test</p>
                    <p class="text-start text_size_header_text_2 font_text_ariblk">{{ date_load }}</p> -->
      </div>
  </section>

  <section v-if="!isMobile" class="otstup ">
      <div class="container_test_grid ">

        <div v-if="$store.state.status_check_filtr == true">
          <Name_level :data_load="$store.state.selectedDate_before_converded +' '+'-'+' '+ $store.state.selectedDate_after_converded"></Name_level>
        </div>
        <div v-if="$store.state.status_check_filtr == false">
          <Name_level :data_load="date_load"></Name_level>
        </div>
        
          <div class="container_grid_inputs">
            
              <!-- кнопка фильтрации по датам -->
              <!-- <a class="no_decoration" href="#">
                
                <div class="container_grid_inputs_input background_inputs" id="showList" role="link" @click.stop="show_drop_down_calendars">
                  <div class="item_test ">
                    <p align="left"  class=" text_size_input  font_text_ariblk">Выбрать дату: </p>
                    
                  </div>
                  
                  
                  <div class="item_test_icon ">
                    <img class="icon_size" src="../../public/Calendar_new.svg" alt="">
                  </div>
                </div>

               
                <div id="listContainer_calendars" class="dropdown-content" style="display: none;">
                  <div v-if="drop_down_calendars">
                    <div class="item_test container_chek_box_calendar">
                        <p align="left"  class="text_size_input_w_color font_text_Arial_regular margin_o">Начало </p>
                        <form >
                          <div v-if="$store.state.selectedDate_before == null">
                            <input id='selectedDate_before' class="calendar_color text_size_input font_text_Arial_regular text-white" v-model="$store.state.selectedDate_before" type="date" name="calendar_before" >
                          </div>
                          <div v-else>
                            <input class="calendar_color text_size_input_calendar font_text_Arial_regular text-white" v-model="$store.state.selectedDate_before" type="date" name="calendar_before" >
                          </div>
                        </form>
                    </div>
                    <div class="item_test container_chek_box_calendar">
                        <p align="left"  class="text_size_input_w_color font_text_Arial_regular margin_o">Конец </p>
                        <form>
                          <div v-if="$store.state.selectedDate_after == null">
                            <input id='selectedDate_after' class="calendar_color text_size_input font_text_Arial_regular text-white" v-model="$store.state.selectedDate_after" type="date" name="calendar_after">
                          </div>
                          <div v-else>
                            <input class="calendar_color text_size_input_calendar font_text_Arial_regular text-white" v-model="$store.state.selectedDate_after" type="date" name="calendar_after">
                          </div>
                          
                        </form>
                    </div>

                    <div class="item_test container_chek_box_calendar_buttons" >
                      
                        <p @click.stop="change_flag_status"  align="left"  class="underline colot_sbros font_text_Arial_regular margin_o">Сбросить</p>
                      
                      
                        <button @click.stop="filtr_on_data" class="my_button font_text_Arial_regular">Применить</button>
                        
                        
                    </div>

                  </div> 
                </div> 

              </a> --> 
              <!-- <a class="no_decoration" href="#">
                <div class="container_grid_inputs_input background_inputs" id="showList" role="link">
                    <div class="item_test ">
                      <p>Текущий год: {{ $store.state.year_change }}</p>
                    </div>
                    
                </div>
                
              </a> -->
              <!-- <a class="no_decoration" href="#"> -->
                <div v-if="$store.state.year_change == 2024" class="container_button_year " id="showList" role="link">

                        <a class="no_decoration" href="#">
                          <div class="item_test_b_year background_inputs_b_year_choosed ocruglen_left" @click.stop="set_24">
                            <p  class="text-white text_size_input_b_year_choused font_text_Arial_regular">2024</p>
                          </div>
                        </a>
                        <a class="no_decoration" href="#">
                          <div class="item_test_b_year background_inputs_b_year " @click.stop="set_25">
                            <p  class="text-white text_size_input_b_year font_text_Arial_regular">2025</p>
                          </div>
                        </a> 
                         <a class="no_decoration" href="#">
                          <div class="item_test_b_year background_inputs_b_year ocruglen_right" @click.stop="set_26">
                            <p  class="text-white text_size_input_b_year font_text_Arial_regular">2026</p>
                          </div>
                        </a>
                        
                   
                </div>
                <div v-if="$store.state.year_change == 2025" class="container_button_year " id="showList" role="link">

                  <a class="no_decoration" href="#">
                    <div class="item_test_b_year background_inputs_b_year ocruglen_left" @click.stop="set_24">
                      <p  class="text-white text_size_input_b_year font_text_Arial_regular">2024</p>
                    </div>
                  </a>
                  <a class="no_decoration" href="#">
                    <div class="item_test_b_year background_inputs_b_year_choosed " @click.stop="set_25">
                      <p class="text-white text_size_input_b_year_choused font_text_Arial_regular">2025</p>
                    </div>
                  </a> 
                   <a class="no_decoration" href="#">
                    <div class="item_test_b_year background_inputs_b_year ocruglen_right" @click.stop="set_26">
                      <p  class="text-white text_size_input_b_year font_text_Arial_regular">2026</p>
                    </div>
                  </a>

                </div>

                <div v-if="$store.state.year_change == 2026" class="container_button_year " id="showList" role="link">

                  <a class="no_decoration" href="#">
                    <div class="item_test_b_year background_inputs_b_year ocruglen_left" @click.stop="set_24">
                      <p  class="text-white text_size_input_b_year font_text_Arial_regular">2024</p>
                    </div>
                  </a>
                  <a class="no_decoration" href="#">
                    <div class="item_test_b_year background_inputs_b_year" @click.stop="set_25">
                      <p  class="text-white text_size_input_b_year font_text_Arial_regular">2025</p>
                    </div>
                  </a>

                  <a class="no_decoration" href="#">
                    <div class="item_test_b_year background_inputs_b_year_choosed ocruglen_right" @click.stop="set_26">
                      <p class="text-white text_size_input_b_year_choused font_text_Arial_regular">2026</p>
                    </div>
                  </a>
                  

                </div>
                
                
                
              <!-- </a> -->
              <!-- <a class="no_decoration" href="#">
                <div class="container_button_year background_inputs" id="showList" role="link" @click.stop="set_25">
                    <div class="item_test ">
                      <p align="left" class="text-white text_size_input font_text_ariblk">2025</p>
                    </div>
                   
                </div>
              </a> -->
              
              <a class="no_decoration" href="#">
                <div class="container_grid_inputs_input background_inputs" id="showList" role="link" @click.stop="show_drop_down_claster">
                    <div class="item_test ">
                      <p align="left" class="text-white text_size_input font_text_ariblk">Выбрать кластер</p>
                    </div>
                    <div class="item_test_icon ">
                      <img class="icon_size" src="../../public/Choose_new.svg" alt="">
                    </div>
                </div>
                <div id="listContainer_claster" class="dropdown-content" style="display: none;">
                      <div v-if="drop_down_list_claster">
                        <div v-for="(post_cl, key) in $store.state.categories_checked">
                          <div class="container_chek_box">
                            <p align="left" class="text-white text_size_input_w_color font_text_Arial_regular margin_o">{{ post_cl }}</p>
                            <input align="left" class="text-white text_size_input font_text_ariblk" :value=post_cl type="checkbox" id="checkbox" v-model="$store.state.categories">
                          </div>
                          
                        </div>
                      </div>

                </div>
              </a>

              
                <div>
                  <!-- Кнопка -->
                  <transition name="v">
                    <router-link 
                      :to="{name: 'home'}" 
                      class="no_decoration" 
                      role="link" 
                      @click.prevent="generatePdf"
                    >
                      <div class="container_grid_inputs_input_button_home_firts_page background_inputs">
                        <div class="item_test_icon button_home">
                          <div v-if="loading_pdf" class="spinner"></div>
                          <img v-if="!loading_pdf" class="icon_size" src="../../public/Export_Icon.svg" alt="">
                        </div>
                      </div>
                    </router-link>
                  </transition>

                  <!-- Сообщения -->
                  <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
                  <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
                </div>
              
              

              <!-- ФИЛЬТР МЕТРИК -->
              
              <!-- <a class="no_decoration" href="#" >
              <div class="container_grid_inputs_input background_inputs" id="showList" role="link" @click.stop="show_drop_down_metrics">
                <div class="item_test">
                  
                  <p  align="left" class="text-white text_size_input font_text_ariblk">Выбрать метрики</p>
                       
                </div>
                
                <div class="item_test_icon ">
                  <img class="icon_size" src="../../public/Choose_new.svg" alt="">
                </div>
              </div>
              <div id="listContainer_metrics" class="dropdown-content" style="display: none;">
                
                      <div v-for="catg in $store.state.categories">
                        <br>
                       
                        <p align="left" class="text-white text_size_filtr_claster_metric font_text_Arial_BoldMT margin_cl">{{ catg }}</p>
                        <div v-for="arr_m_f in $store.state.metric_filtr">
                          
                            <div v-for="cl in data_claster" :key="cl.id">
                              <div v-if="catg == cl.name">
                                <div v-for="bl in post_block" :key="bl.id">
                                  <div v-if="
                                    catg == cl.name
                                    && arr_m_f['claster'] == cl.name
                                    && cl.id == bl.claster_id
                                    && arr_m_f['block_id'] == bl.id
                                    && arr_m_f['block'] != 'Выручка'
                                    ">
                                 
                                    
                                    <p align="left" class="text-white text_size_input_w_color font_text_Arial_regular margin_o">{{ bl.name }}</p>
                                    <div v-for="(pok, index) in arr_m_f.pokazatel" :key="index">
                                      
                                      <div v-if="pok != 'Выручка'" class="container_chek_box">
                                            <p align="left" class="text-white text_size_input_w_color_metric font_text_Arial_regular margin_zero otsup_filtr_metrics">{{ pok }}</p>
                                            
                                            <input class="input text-white text_size_input font_text_ariblk"  :value='pok' type="checkbox" v-model="arr_m_f.pokazatel_cheked">
                                        </div>
                                      
                                    </div>
                                      
                                  </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        
                        
                        


                          

                          </div>
                    </div>
              </a> -->

              <!-- <a class="no_decoration" href="#">
                <div class="container_grid_inputs_input background_inputs ">
                  <div class="item_test ">
                    <p align="left" class="text-white text_size_input font_text_ariblk">Выгрузить отчет</p>
                  </div>
                  <div class="item_test_icon ">
                    <img class="icon_size" src="../../public/Download_new.svg" alt="">
                  </div>
                </div>
              </a> -->

          </div>
          
          <div class="item_test_logo_col">
            <img class="button_back_wc" src="../../public/kronshtadt_mini.svg" alt="">
            <img class="button_back_wc" src="../../public/3_icon.svg" alt="">
            <img class="button_back_wc_isouce" src="../../public/isourse_icon.svg" alt="">
          </div>
          
                    <!-- <p class="text-white text_size_header_text text-start font_text_ariblk">Кронштадт test</p>
                    <p class="text-start text_size_header_text_2 font_text_ariblk">{{ date_load }}</p> -->
      </div>
  </section>



<Our_viruchka_2 :data_ur_lichza="data_ur_lichza" :data_sum="$store.state.sum_plan" :data_sum_fact="$store.state.sum_fact"></Our_viruchka_2>

<!-- <Our_viruchka :data_sum="posts_summer_plan" :data_sum_fact="$store.getters.test_func"></Our_viruchka> -->




<!-- naming blocks -->
<section v-if="isMobile" class="otstup otsup_mimi_up_block">
                <div class="container_test_grid_block_mobile ">
                    
                      <div v-if="$store.state.status_check_filtr == true">
                        <div class="item_test_viruch">
                            <p class="text-white name_blocks  font_text_ariblk">В разрезе кластеров, <span class="text_size_header_text_ed_izmer font_text_Arial_regular">млн ₽</span></p>
                        </div>
                      </div>
                      <div v-if="$store.state.status_check_filtr == false">
                        <div class="item_test_viruch">
                            <p class="text-white name_blocks  font_text_ariblk">{{ $store.state.year_change }} | В разрезе кластеров, <span class="text_size_header_text_ed_izmer color_ed_izmer_ur font_text_Arial_regular">млн ₽</span></p>
                            <!-- text_our_block_ed_izmer_ur color_ed_izmer_ur font_text_Arial_regular -->
                        </div>
                      </div>


                  
                    
                    <!-- <p class="text-white text_size_header_text text-start font_text_ariblk">Кронштадт test</p>
                <p class="text-start text_size_header_text_2 font_text_ariblk">{{ date_load }}</p> -->
                </div>
  </section>


  <section v-if="!isMobile" class="otstup otsup_mimi_up_block">
                <div class="container_test_grid_block ">
                    <div class="container_test_grid_block_in">
                      <div v-if="$store.state.status_check_filtr == true">
                        <div class="item_test_viruch">
                            <p class="text-white name_blocks  font_text_ariblk">Выручка в разрезе бизнес-направлений, <span class="text_size_header_text_ed_izmer color_ed_izmer_ur font_text_Arial_regular">млн ₽</span></p>
                        </div>
                      </div>
                      <div v-if="$store.state.status_check_filtr == false">
                        <div class="item_test_viruch">
                            <p class="text-white name_blocks  font_text_ariblk">{{ $store.state.year_change }} | Выручка в разрезе бизнес-направлений, <span class="text_size_header_text_ed_izmer color_ed_izmer_ur font_text_Arial_regular">млн ₽</span></p>
                        </div>
                      </div>


                    </div>
                    <div class="container_test_grid_block_in item_line" >
                        <div class="item_test_viruch item_line">
                            <p class="text-white name_blocks text-start font_text_ariblk">Ключевые метрики {{ $route.params.id_pokazatel }}</p>
                        </div>
                        <!-- <p class="text-white text_size_header_text text-start font_text_ariblk">Кронштадт test</p>
                    <p class="text-start text_size_header_text_2 font_text_ariblk">{{ date_load }}</p> -->
                    </div>
                    <div class="container_test_grid_block_in item_line" >
                        <div class="item_test_viruch item_line">
                            <p class="text-white name_blocks text-start font_text_ariblk">Уведомления</p>
                        </div>
                        <!-- <p class="text-white text_size_header_text text-start font_text_ariblk">Кронштадт test</p>
                    <p class="text-start text_size_header_text_2 font_text_ariblk">{{ date_load }}</p> -->
                    </div>
                    <!-- <p class="text-white text_size_header_text text-start font_text_ariblk">Кронштадт test</p>
                <p class="text-start text_size_header_text_2 font_text_ariblk">{{ date_load }}</p> -->
                </div>
  </section>
<!-- naming blocks -->






<!-- status_no_filtr -->
 <!-- v-if="isMobile" -->

 

 
<div v-if="$store.state.status_check_filtr == false && isMobile">


<div v-for="categoty in $store.state.categories">
  <div v-for="post_cl in data_claster">
    <!-- <div v-for="post_b in data_claster_block"> -->
    <!-- <div v-for="block in get_claster_block_orig"> -->
      <!-- <div v-if="block.claster_id == post_cl.id"> -->
        <div v-for="post in posts_test_claster_stroki">
        <div v-if="post.posts_test_claster_stroki !== 'None'
        //  && post_cl.id == post_b.claster_id
         && post_cl.id == post.claster_id
        //  && post.block == post_b.name 
         && post_cl.name == categoty
         && post.metric == 'Выручка'
         ">
          
              
              
                
                <section class="otstup otstup_mini">
                      <div>
                        <div class="container_test_grid_block_in">
                          <div class="container_grid_clasters_in_1 Black_2_block_f_p otstup_up_to_clasters">
                            <div class="item_test_claster_block_left_percent">
                              <div v-if="((post.fact/posts_summer_fact)*100).toFixed(2) < 1">
                                <p class="text-white font_text_Arial_BoldMT">{{((post.fact/posts_summer_fact)*100).toFixed(0)}}%</p>
                              </div>
                              <div v-if="((post.fact/posts_summer_fact)*100).toFixed(2) > 1">
                                <p class="text-white font_text_Arial_BoldMT">{{Math.round((post.fact/posts_summer_fact)*100)}}%</p>
                              </div>


                            </div>
                          <router-link :to="{name: 'about', params:{id: post_cl.id}}" class="no_decoration">
                            <div class="item_test_claster_block_left_name">
                              <p align="left" class="text-white font_text_Arial_BoldMT">{{ post_cl.name }}</p>
                              <div class="item_test_metrica_two">
                                  <!-- <div class="item_test_metrica_two" v-model="$store.state.sum_fact+=post.fact"> -->

                                <div v-for="post_p_ot in pokazatel_otstavania">
                                  <div v-if="post_cl.id == post_p_ot.claster_id">
                                    <div v-if="post_p_ot.metric == 'Выручка'">
                                      <div v-if="post_p_ot.color == '0'">
                                      

                                      <div v-if="Number(post.percent)">
                                        <div v-if="post.dinamica_color == '0'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span align="left" class=" text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span align="right"  class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span align="left" title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                          </div>
                                          
                                        </div>
                                        <div v-else-if="post.dinamica_color == '1'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span align="left" title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '2'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span align="left" title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                          </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                      <div v-if="post.dinamica_color == '0'">
                                        <div class="diogram_fact_plan item_line">
                                          <p class="name_year font_text_Arial_BoldMT"><span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          <span align="left" title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span>
                                        </div>
                                      </div>
                                      <div v-else-if="post.dinamica_color == '1'">
                                        <div class="diogram_fact_plan item_line">
                                          <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          <span align="left" title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span>
                                        </div>
                                      </div>
                                      <div v-else-if="post.dinamica_color == '2'">
                                        <div class="diogram_fact_plan item_line">
                                          <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          <span align="left" title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span>
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                      <div v-if="post_p_ot.color == '1'">
                                      

                                        <div v-if="Number(post.percent)">
                                          <div v-if="post.dinamica_color == '0'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span align="left" class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span align="right"  class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                              <span align="left" title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '1'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                              <span align="left" title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '2'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                              <span align="left" title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                            </div>
                                          </div>
                                      </div>
                                      <div v-else>
                                        <div v-if="post.dinamica_color == '0'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span align="left" title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '1'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '2'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span>
                                          </div>
                                        </div>
                                      </div>


                                    </div>
                                    <div v-else-if="post_p_ot.color == '2'">

                                      <div v-if="Number(post.percent)">
                                          <div v-if="post.dinamica_color == '0'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                              <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '1'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                              <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '2'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                              <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span>
                                            </div>
                                          </div>
                                      </div>
                                      <div v-else>
                                        <div v-if="post.dinamica_color == '0'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ post.percent }}%</span>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '1'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ post.percent }}%</span>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '2'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ post.percent }}%</span>
                                          </div>
                                        </div>
                                      </div>

                                    </div>




                                  </div>
                                </div>
                              </div>
                            </div>
                              
                            </div>
                          </router-link>
                            <!-- тут -->
                            <div class="item_test_metrica">
                              <!-- <Progress_circle></Progress_circle :test_var="percentCircle"> -->
                                <!-- <Progress_circle_test :percent="progress_bar_val"/> -->
                                <!-- <div class="item_test_icon "> -->
                                  
                                <!-- </div> -->


                                <div v-for="(post_p_ot, index) in pokazatel_otstavania">
                                    <div v-if="post_cl.id == post_p_ot.claster_id">
                                      <div v-if="post_p_ot.metric == 'Выручка'">
                                        <div v-if="post_p_ot.color == '2'">
                                          <a class="no_decoration" href="#">
                                            <img @click="showModalIndex = index" class="icon_size_notification" src="../../public/vector_notification.svg" alt="">
                                          </a>
                                          

                                          <!-- Модальное окно -->
                                          <transition name="modal">
                                          <div v-if="showModalIndex === index" id="show_modal" class="modal" @click.self="showModalIndex = null">
                                            <div class="modal-content" @click.stop>
                                              <!-- <span @click="showModalIndex = null" class="close">&times;</span> -->
                                              <div class="item_test_icon">
                                                <div class="item_test_nof_text_icon item_line">
                                                  
                                                  <p class="icon_text_nof font_text_Arial_BoldMT"><img class="icon_size_not" src="../../public/info-circle.svg" alt="">{{ formatNumber(Math.abs(post_cl.backlog/1000000)) }} млн руб.</p>
                                                </div>

                                                <div class="item_test_nof_2_stroke item_line">
                                                  <!-- <p align="left" class="noficashion_text font_text_Arial_regular">{{ post_cl.notification }} {{ $store.state.year_change }}</p> -->
                                                  <p align="left" class="noficashion_text font_text_Arial_regular">{{ post_cl.notification }}</p>
                                                </div>
                                              
                                              </div>
                                                
                                                
                                            </div>
                                          </div>
                                          </transition>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                               
                                





                              <!-- <Progress_bar -->  
                            </div>
                            
                          </div>
                                          
                        </div>
                        <!-- Ключевые метрики --> 
                        

                      
                        <!-- Ключевые метрики --> 

                              <!-- <div v-if="post_p_ot.color == '0'"> -->

                                


                      </div>
                </section>
              
              
              
              <!-- <br> -->
          <!-- </div> -->
        
        
          <!-- </div> -->
        <!-- </div> -->
        
    </div>
    <!-- </div> -->
    <!-- </div> -->
  </div>
  <!-- </div> -->
  </div>
</div>

</div>




<div v-if="$store.state.status_check_filtr == false && !isMobile">


<div v-for="categoty in $store.state.categories">
  <div v-for="post_cl in data_claster">
    <!-- <div v-for="post_b in data_claster_block"> -->
    <!-- <div v-for="block in get_claster_block_orig"> -->
      <!-- <div v-if="block.claster_id == post_cl.id"> -->
        <div v-for="post in posts_test_claster_stroki">
        <div v-if="post.posts_test_claster_stroki !== 'None'
        //  && post_cl.id == post_b.claster_id
         && post_cl.id == post.claster_id
        //  && post.block == post_b.name 
         && post_cl.name == categoty
         && post.metric == 'Выручка'
         ">
          
              
              <router-link :to="{name: 'about', params:{id: post_cl.id}}" class="no_decoration">
                
                <section class="otstup otstup_mini">
                      <div class="container_test_grid_block ">
                        <div class="container_test_grid_block_in">
                          <div class="container_grid_clasters_in_1 Black_2_block_f_p otstup_up_to_clasters">
                           
                            <div class="item_test_claster_block_left_name otstup_left">
                              <p align="left" class="text-white font_text_Arial_BoldMT">{{ post_cl.name }}</p>
                            </div>
                            <div class="item_test_metrica">
                              <!-- <Progress_circle></Progress_circle :test_var="percentCircle"> -->
                                <!-- <Progress_circle_test :percent="progress_bar_val"/> -->
                                <div class="circle_diogram">
                                  <!-- <Progress_circle></Progress_circle :test_var="percentCircle"> -->
                                    
                                    <div v-for="post_p_ot in pokazatel_otstavania">
                                      <div v-if="post_cl.id == post_p_ot.claster_id 
                                      && post_p_ot.metric == 'Выручка'
                                      // && post_p_ot.block == post_b.name

                                      ">
                                    
                                          <div v-if="post_p_ot.color == '0'">
                                            <Progress_circle_test :percent="percent=Math.round((post.fact/post.target)*100)" color="grey"/>
                                            
                                          </div>
                                          <div v-else-if="post_p_ot.color == '1'">
                                            <Progress_circle_test :percent="percent=Math.round((post.fact/post.target)*100)" color="green"/>
                                            
                                          </div>
                                          <div v-else-if="post_p_ot.color == '2'">
                                            <Progress_circle_test :percent="percent=Math.round((post.fact/post.target)*100)" color="red"/>
                                            
                                          </div>
                                         
                                      </div>
                                    </div>
                                  <!-- <Progress_bar -->   
                                </div>

                                <div class="item_test_metrica_two">
                                  <!-- <div class="item_test_metrica_two" v-model="$store.state.sum_fact+=post.fact"> -->

                                <div v-for="post_p_ot in pokazatel_otstavania">
                                  <div v-if="post_cl.id == post_p_ot.claster_id">
                                    <div v-if="post_p_ot.metric == 'Выручка'">
                                      <div v-if="post_p_ot.color == '0'">
                                      

                                      <div v-if="Number(post.percent)">
                                        <div v-if="post.dinamica_color == '0'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span align="left" class=" text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span align="right"  class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '1'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '2'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                      <div v-if="post.dinamica_color == '0'">
                                        <div class="diogram_fact_plan item_line">
                                          <p class="name_year font_text_Arial_BoldMT"><span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                        </div>
                                      </div>
                                      <div v-else-if="post.dinamica_color == '1'">
                                        <div class="diogram_fact_plan item_line">
                                          <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                        </div>
                                      </div>
                                      <div v-else-if="post.dinamica_color == '2'">
                                        <div class="diogram_fact_plan item_line">
                                          <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                      <div v-if="post_p_ot.color == '1'">
                                      

                                        <div v-if="Number(post.percent)">
                                          <div v-if="post.dinamica_color == '0'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span align="left" class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span align="right"  class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '1'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '2'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            </div>
                                          </div>
                                      </div>
                                      <div v-else>
                                        <div v-if="post.dinamica_color == '0'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '1'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '2'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="green_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{post.percent}}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                      </div>


                                    </div>
                                    <div v-else-if="post_p_ot.color == '2'">

                                      <div v-if="Number(post.percent)">
                                          <div v-if="post.dinamica_color == '0'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '1'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            </div>
                                          </div>
                                          <div v-else-if="post.dinamica_color == '2'">
                                            <div class="diogram_fact_plan item_line">
                                              <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ Number(post.percent).toFixed(1) }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                            </div>
                                          </div>
                                      </div>
                                      <div v-else>
                                        <div v-if="post.dinamica_color == '0'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="white_text_bg black_text dinamica_claster font_text_Arial_regular">{{ post.percent }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '1'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="green_text_bg white_text dinamica_claster font_text_Arial_regular">{{ post.percent }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else-if="post.dinamica_color == '2'">
                                          <div class="diogram_fact_plan item_line">
                                            <p class="name_year font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> <span title="Динамика к прошлой неделе" class="red_text_bg white_text dinamica_claster font_text_Arial_regular">{{ post.percent }}%</span> <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                      </div>

                                    </div>




                                  </div>
                                </div>
                              </div>
                            </div>
                                





                              <!-- <Progress_bar -->  
                            </div>
                            
                          </div>
                                          
                        </div>
                        <!-- Ключевые метрики --> 
                        

                        <div class="container_test_grid_block_in item_line">
                          <div class="container_grid_clasters_in_2 Black_2_block_f_p item_line otstup_up_to_clasters ">
                            
                            
                            <!-- post_f_p_cl.data[0][1].show -->
                            <div v-for="ch_b in $store.state.metric_filtr_check_box">
                              <!-- <div><p>{{ ch_b }}</p></div> -->

                            <div v-for="post in data_pokazatel">
                              <div v-if="post.posts_test_claster_stroki !== 'None'
                              && post_cl.id == ch_b.claster_id
                              && post.block_id == ch_b.block_id
                              && post.claster_id == ch_b.claster_id
                              ">
                              <!-- <div v-for="ch_b_pok in ch_b.pokazatel"> -->
                                <div v-if="ch_b.pokazatel == post.metric">
                                
                                  
                                    
                                  
    

                            <!-- <div v-if="post.metric != 'Выручка'"> -->
                              <!-- <div v-if="post_a_p == post.metric"> -->

                            
                            <div class="item_test_colonka item_line line_right">
                              <div v-if="post.ed_izmer != 'руб.'">
                                <div class="comp_test">
                                  <p align="left" class="name_razdel text-white font_text_Arial_BoldMT">{{post.metric}},</p>
                                  <p align="left" class="name_razdel otstup_razdel text-white font_text_Arial_BoldMT otstup_l_1_ed_izmer"><span class="text_size_header_text_ed_izmer_razdel font_text_Arial_regular">{{ post.ed_izmer }}</span></p>
                                </div>
                              </div> 
                              <div v-else>
                                <div class="comp_test">
                                  <p align="left" class="name_razdel text-white font_text_Arial_BoldMT">{{post.metric}},</p>
                                  <p align="left" class="name_razdel otstup_razdel text-white font_text_Arial_BoldMT otstup_l_1_ed_izmer"><span class="text_size_header_text_ed_izmer_razdel font_text_Arial_regular">млн {{ post.ed_izmer }}</span></p>
                                </div>
                              </div>
                              
                            
                              <div class="comp_test">
                                <p class="name_year text-white font_text_Arial_BoldMT">{{ $store.state.year_change }}</p>
                              </div>


                              <div class="h_diogram">
                                
                                  
                                    

                                      <div v-if="post.color == '0'">
                                        <Progress_bar maxWidth="" :percent="(post.fact/post.target)*100" color="grey-hover"></Progress_bar>
                                      </div>
                                      <div v-else-if="post.color == '1'">
                                        <div v-if="(post.fact/post.target)*100 <= 100">
                                          <div v-if="post.fact < 0 || post.target < 0">
                                               <Progress_bar maxWidth="200" :percent="((post.target/post.fact)*100)" color="red" over='true'></Progress_bar>                           

                                          </div>
                                          <div v-else>
                                               <Progress_bar maxWidth="200" :percent="((post.target/post.fact)*100)" color="green" over='true'></Progress_bar>                          

                                          </div>
                                          <!-- <Progress_bar maxWidth="200" :percent="(post.fact/post.target)*100" color="green"></Progress_bar> -->
                                        </div>
                                        <div v-else-if="(post.fact/post.target)*100 > 100">
                                          <div v-if="post.fact < 0 || post.target < 0">
                                               <Progress_bar maxWidth="200" :percent="((post.target/post.fact)*100)" color="red" over='true'></Progress_bar>                           

                                          </div>
                                          <div v-else>
                                               <Progress_bar maxWidth="200" :percent="((post.target/post.fact)*100)" color="green" over='true'></Progress_bar>                          
                                          </div>
                                          
                                        </div>
                                      </div>
                                      <div v-else-if="post.color == '2'">
                                        <Progress_bar maxWidth="" :percent="(post.fact/post.target)*100" color="red"></Progress_bar>
                                      </div>
                                      
                                    
                                  
                                
                              </div>



                                
                                  
                                    
                                      <div v-if="post.color == '0'">

                                        <div v-if="post.ed_izmer == 'руб.'">
                                          
                                          <div class="razdel_fact item_line">
                                            <p class="name_year text-white font_text_Arial_BoldMT"><span class="white_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else>
                                          <div class="razdel_fact item_line">
                                              <p class="name_year text-white font_text_Arial_BoldMT"><span :class="[parseInt(post.fact) < 0 ? 'red_text' : 'white_text', 'text_size_header_text_ed_izmer_razdel_fact', 'font_text_Arial_BoldMT']">{{ parseInt(post.fact) }}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{ parseInt(post.target) }}</span></p>
                                          </div>
                                        </div>

                                      </div>
                                      <div v-if="post.color == '1'">

                                      <div v-if="post.ed_izmer == 'руб.'">
                                        <div class="razdel_fact item_line">
                                          <p class="name_year text-white font_text_Arial_BoldMT"><span :class="[parseInt(post.fact) < 0 ? 'red_text' : 'green_text', 'text_size_header_text_ed_izmer_razdel_fact', 'font_text_Arial_BoldMT']">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                        </div>
                                      </div>
                                      <div v-else>
                                        <div class="razdel_fact item_line">
                                            <p class="name_year text-white font_text_Arial_BoldMT"><span :class="[parseInt(post.fact) < 0 ? 'red_text' : 'green_text', 'text_size_header_text_ed_izmer_razdel_fact', 'font_text_Arial_BoldMT']">{{ parseInt(post.fact) }}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{ parseInt(post.target) }}</span></p>
                                        </div>
                                      </div>

                                      </div>
                                      <div v-else-if="post.color == '2'">

                                        <div v-if="post.ed_izmer == 'руб.'">
                                          <div class="razdel_fact item_line">
                                            <p class="name_year text-white font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.fact/1000000))}}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{formatNumber((post.target/1000000))}}</span></p>
                                          </div>
                                        </div>
                                        <div v-else>
                                            <div class="razdel_fact item_line">
                                                <p class="name_year text-white font_text_Arial_BoldMT"><span class="red_text text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{ parseInt(post.fact) }}</span> из <span class="text_size_header_text_ed_izmer_razdel_fact font_text_Arial_BoldMT">{{ parseInt(post.target) }}</span></p>
                                            </div>
                                        </div>

                                      </div>
                                    
                                  
                                


                            
                            </div>

                          
                          
                        
                          </div>
                          <!-- </div> -->
                            
                      </div>
                      </div>
                      
                    
                          <!-- </div> -->
                          
                            
                            </div>
                            
                            
                            
                    </div>
                  </div>
                        <!-- Ключевые метрики --> 

                              <!-- <div v-if="post_p_ot.color == '0'"> -->

                                <div class="container_test_grid_block_in item_line">

                                  <div v-for="post_p_ot in pokazatel_otstavania">
                                    <div v-if="post_cl.id == post_p_ot.claster_id">
                                      <div v-if="post_p_ot.metric == 'Выручка'">


                                        <div v-if="post_p_ot.color == '0'">

                                          <div class="container_grid_clasters_in_3 Black_2_block_notification item_line otstup_up_to_clasters">
                                      
                                            <div class="item_test_nof_text item_line">
                                              <p align="left" class="noficashion_text font_text_Arial_BoldMT">{{ " " }}</p>
                                            </div>
                                          </div>

                                        </div>


                                  <div v-if="post_p_ot.color == '1'">

                                                                
                                    <div class="container_grid_clasters_in_3 Black_2_block_notification item_line otstup_up_to_clasters">
                                      
                                      <div class="item_test_nof_text item_line">
                                        <p align="left" class="noficashion_text font_text_Arial_BoldMT">{{ " " }}</p>
                                      </div>
                                    </div>


                                  </div>

                                  <div v-if="post_p_ot.color == '2'">

                                
                                    <div class="container_grid_clasters_in_3 Black_2_block bg_color_red item_line otstup_up_to_clasters">
                                    <div class="item_test_icon_dekstop">
                                                <div class="item_test_nof_text_icon item_line">
                                                  
                                                  <p class="icon_text_nof font_text_Arial_BoldMT"><img class="icon_size_not" src="../../public/info-circle.svg" alt="">{{ formatNumber(Math.abs(post_cl.backlog/1000000)) }} млн руб.</p>
                                                </div>

                                                <div class="item_test_nof_2_stroke item_line">
                                                  <p align="left" class="noficashion_text font_text_Arial_regular">{{ post_cl.notification }}</p>
                                                </div>
                                              
                                    </div>
                                      <!-- <div class="item_test_nof_icon otstup_up_blocks item_line">
                                        <img class="icon_size_not" src="../../public/info-circle.svg" alt="">
                                      </div>
                                      <div class="item_test_nof_text item_line">
                                        <p align="left" class="noficashion_text font_text_Arial_BoldMT">{{ post_cl.notification }}</p>
                                      </div> -->
                                    </div>

                                    


                                  </div>


                                        </div>
                                  </div>
                                </div>



                                </div>


                      </div>
                </section>
              
              </router-link>
              
              <!-- <br> -->
          <!-- </div> -->
        
        
          <!-- </div> -->
        <!-- </div> -->
        
    </div>
    <!-- </div> -->
    <!-- </div> -->
  </div>
  <!-- </div> -->
  </div>
</div>

</div>



<!-- status_no_filtr -->


<!-- status_filtr -->

<!-- status_filtr -->



</div>
</template>

<script>
    // @ is an alias to /src
    import HelloWorld from '@/components/HelloWorld.vue'
    import Name_level from '@/components/Name_level.vue'
    // import { ref } from 'vue'
    import Progress_bar from '@/components/Progress_bar.vue'
    import Progress_circle from '@/components/Progress_circle.vue'
    import Progress_circle_test from '@/components/Progress_circle_test.vue'
    import Our_viruchka from '@/components/Our_viruchka.vue'
    import Our_viruchka_2 from '@/components/Our_viruchka_2.vue'
    import axios from 'axios'
    import Datepicker from 'vuejs3-datepicker'
    import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
    import { ref, onMounted, onBeforeUnmount } from 'vue'
    // import ChildComponent from './App.vue';



    export default {

        name: 'HomeView',
        components: {
            HelloWorld, Name_level, Progress_bar, Progress_circle, Progress_circle_test, Our_viruchka, Datepicker, Our_viruchka_2
        },
        data() {

            return {
                port:process.env.VUE_APP_DASHBOARD_URL,
                name_level: [{ id: 1, name: 'Кронштадт' }],
                progress_bar_val: 5,
                progress_circle_val: 60,
                date_load: [],
                data_claster: [],
                data_claster_block: [],
                posts_test_claster_stroki: [],
                posts_summer_fact: [],
                posts_summer_plan: [],
                arr_pokasatel:[""],
                pokazatel_otstavania: [],
                data_pokazatel: [],
                post_block:[],
                pokazatel_otstavania_first_page: [],
                // state: [{date: new Date(2016, 9,  16)}],
                state: [],
                filtr_pokazatel_claster:[],
                post_filter_metrics:[],
                arr_pokasatel_arr: [],
                drop_down_list_metrics: ref(false),
                drop_down_list_claster: ref(false),
                drop_down_calendars: ref(false),
                isMobile: false,
                // selected_Date_arr: [],
                check_arr: [
                  {'name': 'drop_down_list_metrics', 'ckeck': false}, 
                  {'name': 'drop_down_list_claster', 'ckeck': false},
                  {'name': 'drop_down_calendars', 'ckeck': false},
                ],
                data_ur_lichza:[],
                showModal: false,
                showModalIndex: null,
                isLoading: false,
                loading_pdf: false,
                errorMessage: null,
                successMessage: null  


            }
        },

        // state: {
        //   disabledDates: {
        //     to: new Date(2016, 0, 5), // Disable all dates up to specific date
        //     from: new Date(2016, 0, 26), // Disable all dates after specific date
            
        //     dates: [ // Disable an array of dates
        //       // new Date(2016, 9, 16),
        //       // new Date(2016, 9, 17),
        //       // new Date(2016, 9, 18)
        //     ],
        //     preventDisableDateSelection: true
        //   }
        // },

        methods: {
            ...mapActions({
              fetchPosts_count_sum: 'fetchPosts_count_sum',
            }),

            checkScreenSize() {
              this.isMobile = window.matchMedia('(max-width: 430px)').matches;
            },

        //     formatNumber(number) {
        //   return number
        //     .toLocaleString('ru-RU', {
        //       minimumFractionDigits: 1,
        //       maximumFractionDigits: 1,
        //     })
        //     .replace(',', '.'); 
        // },

        closeModal(e) {
      if (e.target === e.currentTarget) {
        this.showModal = false;
      }
    },


            // скрытие списка
            hideDialog(){
              const listContainer_claster = document.getElementById('listContainer_claster');
              const listContainer_metrics = document.getElementById('listContainer_metrics');
              const listContainer_calendar = document.getElementById('listContainer_calendars');

              if (listContainer_claster.style.display != 'none' || listContainer_metrics.style.display != 'none' || listContainer_calendar.style.display != 'none'){
                listContainer_claster.style.display = 'none';
                listContainer_metrics.style.display = 'none';
                listContainer_calendar.style.display = 'none';

                this.drop_down_list_claster = false;
                this.drop_down_calendars = false;
                this.drop_down_list_metrics == false
              }
              // this.$emit('update:show', false)
              // for (var i=0; i<=this.check_arr.length-1; i++){
              //   console.log(this.check_arr[i])
              //   listContainer_claster.style.display = 'none';
              //   listContainer_metrics.style.display = 'none';
              //   listContainer_calendar.style.display = 'none';
              // }
            },


            // фильтрация_по_переудам
            async filtr_on_data() { 

              // проверка на пустые значения
              // console.log(this.selectedDate)
              
              const selectedDate_before_el = document.getElementById('selectedDate_before');
              const selectedDate_after_el = document.getElementById('selectedDate_after');
              if (this.$store.state.selectedDate_before == null & this.$store.state.selectedDate_after == null){
                
                selectedDate_before_el.style.border = '1px solid #e70707'
                selectedDate_after_el.style.border = '1px solid #e70707'
              } if (this.$store.state.selectedDate_after == null) {
                // const selectedDate_before_el = document.getElementById('selectedDate_after');
                selectedDate_after_el.style.border = '1px solid #e70707'
              } if (this.$store.state.selectedDate_before == null) {
                // const selectedDate_before_el = document.getElementById('selectedDate_before');
                selectedDate_before_el.style.border = '1px solid #e70707'
              } if (this.$store.state.selectedDate_before != null & this.$store.state.selectedDate_after != null){
 

              // фильтрация по дате
              const response = await axios.post(this.port + '/filtr_on_data', {
              date_before: this.$store.state.selectedDate_before,
              date_after: this.$store.state.selectedDate_after,
              });
              this.$store.state.selected_Date_arr = response.data;
              // console.log(this.selected_Date_arr);
              this.$store.state.status_check_filtr = true;
              

              // конвертация даты
              const response_convert_data = await axios.post(this.port + '/convert_data', {
              date_before: this.$store.state.selectedDate_before,
              date_after: this.$store.state.selectedDate_after,
              });
              // console.log(response_convert_data.data[0]['date_before']);
              // console.log(response_convert_data.data[0]['date_after']);
              this.$store.state.selectedDate_before_converded = response_convert_data.data[0]['date_before']
              this.$store.state.selectedDate_after_converded = response_convert_data.data[0]['date_after']
              }

              

            },

            change_flag_status(){
              this.$store.state.status_check_filtr = false;
              // console.log(this.$store.state.status_check_filtr);
              this.$store.state.selectedDate_before = null;
              this.$store.state.selectedDate_after = null;
              
            },


            show_drop_down_metrics() {
                const listContainer_claster = document.getElementById('listContainer_claster');
                // const listContainer_metrics = document.getElementById('listContainer_metrics');
                // const listContainer_calendar = document.getElementById('listContainer_calendars');

                for (var i=0; i<=this.check_arr.length-1; i++) {
                  if (this.check_arr[i]['name'] == 'drop_down_list_metrics') {

                    this.drop_down_list_metrics = !this.drop_down_list_metrics
                    if (this.drop_down_list_metrics == true){
                      // listContainer_metrics.style.display = 'block';
                      listContainer_claster.style.display = 'none';
                      // listContainer_calendar.style.display = 'none';
                    }
                    if (this.drop_down_list_metrics == false){
                      // listContainer_metrics.style.display = 'none';
                    }
                  } else {
                    this.drop_down_list_claster = false;
                    this.drop_down_calendars = false;
                  }

                }
                
                
                },

                async set_24() {
                    if (this.isLoading) return;
                    
                    this.isLoading = true;
                    this.$store.commit('SET_YEAR', 2024);
                    
                    try {
                        await Promise.all([
                            this.fetchPosts_date_loader(),
                            this.fetchPosts_test_claster(),
                            this.fetchPosts_test_claster_stroki(),
                            this.fetchPosts_test_claster_block(),
                            this.fetchPosts_data_pokazatel_otstavania(),
                            this.fetchPosts_date_ur_lichza(),
                            this.fetchPosts_dinamic_claster()
                        ]);
                    } catch (e) {
                        console.error("Ошибка загрузки данных:", e);
                    } finally {
                        this.isLoading = false;
                    }
                },
                async set_25() {
                    if (this.isLoading) return;
                    
                    this.isLoading = true;
                    this.$store.commit('SET_YEAR', 2025);
                    
                    try {
                        await Promise.all([
                            this.fetchPosts_date_loader(),
                            this.fetchPosts_test_claster(),
                            this.fetchPosts_test_claster_stroki(),
                            this.fetchPosts_test_claster_block(),
                            this.fetchPosts_data_pokazatel_otstavania(),
                            this.fetchPosts_date_ur_lichza(),
                            this.fetchPosts_dinamic_claster()
                        ]);
                    } catch (e) {
                        console.error("Ошибка загрузки данных:", e);
                    } finally {
                        this.isLoading = false;
                    }
                },

                async set_26() {
                    if (this.isLoading) return;
                    
                    this.isLoading = true;
                    this.$store.commit('SET_YEAR', 2026);
                    
                    try {
                        await Promise.all([
                            this.fetchPosts_date_loader(),
                            this.fetchPosts_test_claster(),
                            this.fetchPosts_test_claster_stroki(),
                            this.fetchPosts_test_claster_block(),
                            this.fetchPosts_data_pokazatel_otstavania(),
                            this.fetchPosts_date_ur_lichza(),
                            this.fetchPosts_dinamic_claster()
                        ]);
                    } catch (e) {
                        console.error("Ошибка загрузки данных:", e);
                    } finally {
                        this.isLoading = false;
                    }
                },

                formatNumber(num) {
              // Проверяем, что num является числом (или строкой, которую можно преобразовать в число)
              if (num === null || num === undefined || isNaN(num)) {
                return ''; // или можно вернуть '0', 'N/A' или другое значение по умолчанию
              }

              // Преобразуем в число, если это строка
              const number = typeof num === 'string' ? parseFloat(num) : num;

              // Проверяем, целое ли число (учитываем и 21000.0)
              const isInteger = Number.isInteger(number);

              // Округляем до 1 знака после запятой, если число не целое
              const roundedNum = isInteger ? number : parseFloat(number.toFixed(1));

              // Форматируем с пробелами и заменяем точку на запятую
              let formatted = roundedNum
                .toString()
                .replace('.', ',') // Меняем точку на запятую
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // Добавляем пробелы

              // Убираем ",0" у целых чисел (например, "21 000,0" → "21 000")
              if (isInteger) {
                formatted = formatted.replace(/,0$/, '');
              }

              return formatted;
            },
                

                show_drop_down_claster() {
                    this.drop_down_list_claster = !this.drop_down_list_claster;
                    const listContainer = document.getElementById('listContainer_claster');
                    listContainer.style.display = this.drop_down_list_claster ? 'block' : 'none';
                    
                    // Добавляем/удаляем обработчик клика по документу
                    if (this.drop_down_list_claster) {
                      document.addEventListener('click', this.closeMenuOnClickOutside);
                    } else {
                      document.removeEventListener('click', this.closeMenuOnClickOutside);
                    }
                  },
                  
                  closeMenuOnClickOutside(event) {
                    const listContainer = document.getElementById('listContainer_claster');
                    const triggerElement = document.getElementById('showList');
                    
                    // Если клик был не по меню и не по триггеру
                    if (!listContainer.contains(event.target) && !triggerElement.contains(event.target)) {
                      this.drop_down_list_claster = false;
                      listContainer.style.display = 'none';
                      document.removeEventListener('click', this.closeMenuOnClickOutside);
                    }
                  },
            




            async generatePdf() {
              this.loading_pdf = true; // Активируем индикатор загрузки
              this.errorMessage = null;
              this.successMessage = null;

              try {
                const selectedCategories = this.$store.state.categories_checked;
                console.log("selectedCategories: ", selectedCategories);

                const clusterIds = Object.keys(selectedCategories)
                  .map(Number)
                  .map(id => id + 1);
                console.log("clusterIds: ", clusterIds);

                // if (clusterIds.length === 0) {
                //   this.errorMessage = "Пожалуйста, выберите хотя бы одну категорию.";
                //   this.loading_pdf = false;
                //   return;
                // }

                const response = await fetch(this.dynamicPort_PDF + '/generate_pdf', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ cluster_id: clusterIds })
                });

                if (!response.ok) {
                  throw new Error(`Ошибка сервера: ${response.status} ${response.statusText}`);
                }

                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'archive.zip';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(downloadUrl);

                // this.successMessage = "Файл успешно сгенерирован!";
                // setTimeout(() => {
                //   this.successMessage = null;
                // }, 3000);

              } catch (error) {
                console.error('Ошибка:', error);
                this.errorMessage = error.message || "Произошла ошибка при генерации PDF.";
              } finally {
                this.loading_pdf = false; // Завершаем индикатор загрузки
              }
            },


                  

            show_drop_down_calendars() {
                const listContainer_claster = document.getElementById('listContainer_claster');
                // const listContainer_metrics = document.getElementById('listContainer_metrics');
                // const listContainer_calendar = document.getElementById('listContainer_calendars');
                for (var i=0; i<=this.check_arr.length-1; i++) {

                  if (this.check_arr[i]['name'] == 'drop_down_calendars'){
                    this.drop_down_calendars = !this.drop_down_calendars
                
                  if (this.drop_down_calendars == true){
                    // listContainer_calendar.style.display = 'block';
                    listContainer_claster.style.display = 'none';
                    // listContainer_metrics.style.display = 'none';
                  }
                  if (this.drop_down_calendars == false){
                    listContainer_calendar.style.display = 'none';
                    // this.drop_down_list_claster = !this.drop_down_list_claster
                    // this.drop_down_list_metrics = !this.drop_down_list_metrics
                  }
                    
                  } else {
                    this.drop_down_list_metrics = false;
                    this.drop_down_list_claster = false;
                  }
                }
                
                
              },
            async fetchPosts_date_loader() {
                try {
                    this.isPostsLoading = true
                    const response1 = await axios.get(this.dynamicPort + '/get_dater');
                    this.date_load = response1.data[0]['date_vrem'];
                    // this.posts1 = response1.data;

                } catch (e) {
                    // alert("Error date_loader")
                }
            },
            async fetchPosts_test_claster() {
                try{
                    this.isPostsLoading = true
                    // const response = await axios.get('http://127.0.0.1:8000/api/BlockObespechTovars');
                    const response_block = await axios.get(this.dynamicPort + '/get_claster_stroki');
                    this.data_pokazatel = response_block.data;
                    const response1 = await axios.get(this.dynamicPort + '/get_claster');
                    this.data_claster = response1.data;
                    // var arr_filtr_pokazatel_claster = [];

                    for (var i=0; i<=response1.data.length-1; i++) {
                        // console.log("id: "+i)
                        this.filtr_pokazatel_claster.push({"id":i+1, "name":response1.data[i].name, "data":[]})
                        var arr_filtr_pokazatel_claster = [];
                        for (var j=0; j<=response_block.data.length-1; j++){
                          if (response1.data[i].id == response_block.data[j].claster_id){
                            // console.log('id_claster: '+response1.data[i].id)
                            // console.log('id_pokazatel: '+response_block.data[j].claster_id)
                            arr_filtr_pokazatel_claster.push({'id': j+1,'pokazatel':response_block.data[j].name, 'show': false})
                          }
                        }
                        this.filtr_pokazatel_claster[i]['data'].push(arr_filtr_pokazatel_claster)

                    }
                    

                    // console.log("PORT = " + this.port)


                    
                } catch (e) {
                    // alert("Error")
                }
            },
            async fetchPosts_test_claster_stroki() {
                try{
                    const response_filtr_pokazat = await axios.get(this.dynamicPort_Adminka + '/admin_pokazatel');
                    this.$store.state.metric_filtr_check_box = response_filtr_pokazat.data;


                    // console.log('Функция строк запущена')
                    this.$store.state.sum_fact = 0
                    this.$store.state.sum_plan = 0
                    // console.log(this.$store.state.categories)
                    this.isPostsLoading = true
                    // const response = await axios.get('http://127.0.0.1:8000/api/BlockObespechTovars');
                    const response_cl = await axios.get(this.dynamicPort + '/get_claster');
                    const response1 = await axios.post(this.dynamicPort + '/get_claster_stroki_dinamica', {
                      first_page:1
                    });
                    // const response2 = await axios.get(this.port + '/get_claster_stroki');
                    
                    
                    this.posts_test_claster_stroki = response1.data;
                    // const test_sum = JSON.stringify(Object.assign({}, this.posts_test_claster_stroki), null, 2);
                    // const test_sum = JSON.stringify((response1.data), null, 2);
                    var sum_var = 0
                    var sum_var_fact = 0
                    for (var cl_store=0; cl_store<=this.$store.state.categories.length-1; cl_store++){
                        // console.log(this.$store.state.categories[cl_store])
                        for (var cl=0; cl<=response_cl.data.length-1; cl++) {
                          if (response_cl.data[cl].name === this.$store.state.categories[cl_store]) {
                            // console.log(response_cl.data[cl].name)
                          }

                          for (var i=0; i<=response1.data.length-1; i++){
                            if (response1.data[i].metric == 'Выручка' && response_cl.data[cl].name === this.$store.state.categories[cl_store] && response1.data[i].claster_id === response_cl.data[cl].id) {
                              this.$store.state.sum_fact+=parseFloat(String(response1.data[i].fact.match(/\d+/g)))
                              this.$store.state.sum_plan+=parseFloat(String(response1.data[i].target.match(/\d+/g)))
                            }
                              
                          }
                          
                        }

                    }

              
                      for (var i=0; i<=response1.data.length-1; i++){
                        if (response1.data[i].metric == 'Выручка') {
                          sum_var+=parseFloat(String(response1.data[i].target.match(/\d+/g)))
                          // const matches = response1.data[i].fact.match(/(\d+)/);
                          // console.log("Элемент [ "+ i +" ] = " + response1.data[i].fact.match(/\d+/g));
                          // console.log("Сумма plan = " + sum_var)
                        }
                          
                      }
                    
                    this.posts_summer_plan = String(sum_var)

                    for (var i=0; i<=response1.data.length-1; i++){
                      if (response1.data[i].metric == 'Выручка') {
                        sum_var_fact+=parseFloat(String(response1.data[i].fact.match(/\d+/g)))
                        // const matches = response1.data[i].fact.match(/(\d+)/);
                        // console.log("Элемент [ "+ i +" ] = " + response1.data[i].fact.match(/\d+/g));
                        // console.log("Сумма plan = " + sum_var_fact)
                      }
                        
                    }
                    this.posts_summer_fact = String(sum_var_fact)

                    // for (var i=0; i<=response1.data.length-1; i++){
                    //   sum_var+=Number(response1.data[i].fact.match(/\d+/g))
                    //   // const matches = response1.data[i].fact.match(/(\d+)/);
                    //   // console.log("Элемент [ "+ i +" ] = " + response1.data[i].fact.match(/\d+/g));
                    //   // console.log("Сумма = " + sum_var)
                    // }
                    // this.posts_summer_fact = sum_var
                    // console.log("test = " + response1.data[0].fact )
                    // this.isPostsLoading = false;

                    // this.posts1 = response1.data;
                    
                } catch (e) {
                    // alert("Error fetchPosts_test_claster_stroki")
                }
            },
            async fetchPosts_test_claster_block() {
                try{
                    this.isPostsLoading = true
                    // const response = await axios.get('http://127.0.0.1:8000/api/BlockObespechTovars');
                    const response_cl = await axios.get(this.dynamicPort + '/get_claster');
                    const response_block = await axios.get(this.dynamicPort + '/get_claster_block');
                    this.post_block = response_block.data;
                    const response_bl = await axios.get(this.dynamicPort + '/get_claster_stroki');
                    this.data_claster_block = response_bl.data;

                    for (var cl=0; cl<=response_cl.data.length-1; cl++) {
                      
                      let arr_metrics = [];
                      for (var bl=0; bl<=response_bl.data.length-1; bl++){
                        if (response_cl.data[cl].id === response_bl.data[bl].claster_id)
                          // name_clasters
                          // console.log(response_bl.data[bl].name)
                          // console.log(this.$store.state.metric_filtr[1])
                          arr_metrics.push(response_bl.data[bl].name)
                          // this.$store.state.metric_filtr[1] = [response_bl.data[bl].name]                   
                      }
                      // console.log(arr_metrics)
                      // this.$store.state.metric_filtr['metrics'] = arr_metrics
                      // this.$store.state.metric_filtr.push({'claster_id':response_cl.data[cl].id,'name_claster':response_cl.data[cl].name, 'metrics': [arr_metrics]})
                       
                    }

                  
                    
                } catch (e) {
                    // alert("Error")
                }
            },

            async fetchPosts_data_pokazatel_otstavania() {
                try {
                  // get_pokazatel_otstavania
                    this.isPostsLoading = true
                    const response1 = await axios.get(this.dynamicPort + '/get_pokazatel_otstavania_first_page');
                    this.pokazatel_otstavania = response1.data;

                    // const response2 = await axios.get(this.port + '/get_pokazatel_otstavania_first_page');
                    // this.pokazatel_otstavania_first_page = response2.data;

                    // pokazatel_otstavania_first_page
                    // this.posts1 = response1.data;

                } catch (e) {
                    // alert("Error date_loader")
                }
            },
            async fetchPosts_metrics_filtred() {
                  try{

                      this.isPostsLoading = true
                      // const response = await axios.get('http://127.0.0.1:8000/api/BlockObespechTovars');
                      const response_cl = await axios.get(this.dynamicPort + '/get_claster');
                      const response_bl = await axios.get(this.dynamicPort + '/get_claster_block');
                      const response_st = await axios.get(this.dynamicPort + '/get_claster_stroki');
                      this.data_claster_block = response_bl.data;

                      for (var cl=0; cl<=response_cl.data.length-1; cl++) {
                        let arr_pokazat = [];
                        for (var bl=0; bl<=response_bl.data.length-1; bl++){
                          for (var st=0; st<=response_st.data.length-1; st++){
                          if (response_cl.data[cl].id === response_st.data[st].claster_id 
                              && response_st.data[st].metric != "Выручка"
                              && response_cl.data[cl].id === response_bl.data[bl].claster_id 
                              && response_bl.data[bl].id === response_st.data[st].claster_id
                            ){
                            arr_pokazat.push(response_st.data[st].metric)
                          }
                        }
                        }
                        
                        
                        let arr_metrics = [];
                        for (var bl=0; bl<=response_bl.data.length-1; bl++){
                          if (response_cl.data[cl].id === response_bl.data[bl].claster_id)
                            // name_clasters
                            // console.log(response_bl.data[bl].name)
                            // console.log(this.$store.state.metric_filtr[1])
                            arr_metrics.push(response_bl.data[bl].name)
                                              
                        }
                        // console.log(arr_metrics)
                        // console.log(arr_pokazat.slice(1, 3))
                        
                        // this.$store.state.metric_filtr.push({'claster_id':response_cl.data[cl].id,'name_claster':response_cl.data[cl].name, 'metrics': [arr_metrics]})
                        // this.$store.state.metric_filtr_check_box.push(arr_pokazat.slice(0, 2)[0])
                        // this.$store.state.metric_filtr_check_box.push(arr_pokazat.slice(0, 2)[1])
                        
                      }
                      console.log(this.$store.state.metric_filtr_check_box)

                  // console.log($store.state.metric_filtr_check_box)
                    
                      
                  } catch (e) {
                      // alert("Error")
                  }
              },
              async fetchPosts_dinamic_claster() {
                this.$store.state.categories = [];
                this.$store.state.categories_checked = [];
                
                const response_get_claster = await axios.get(this.dynamicPort + '/get_claster');
                
                // Сортируем данные по critical_flag (по возрастанию, "0" будут первыми)
                const sortedData = response_get_claster.data.sort((a, b) => {
                    return Number(a.critical_flag) - Number(b.critical_flag);
                });
                
                for (var cl = 0; cl < sortedData.length; cl++) {
                    this.$store.state.categories.push(sortedData[cl]['name']);
                    this.$store.state.categories_checked.push(sortedData[cl]['name']);
                }
            },
            async fetchPosts_date_ur_lichza() {
                try {
                    this.isPostsLoading = true
                    // const response1 = await axios.get(this.port + '/GET_UR_LICHZA');
                    // this.data_ur_lichza = response1.data;

                    const response1 = await axios.get(this.dynamicPort + '/GET_UR_LICHZA', {
                      params: {  // Query-параметры (появятся в URL после ?)
                        year: this.$store.state.year_change
                      },
                      headers: {  // Заголовки запроса (не видны в URL)
                        'Authorization': '',
                        'X-Custom-Header': ''
                      }
                    });
                    this.data_ur_lichza = response1.data;


                    // динамическая фильтрация
                    const response_get_filter_metrics = await axios.get(this.dynamicPort + '/get_filter_metrics');
                    // this.post_filter_metrics = response_get_filter_metrics.data;
                    this.$store.state.metric_filtr = response_get_filter_metrics.data;

                    // this.posts1 = response1.data;

                } catch (e) {
                    // alert("Error date_loader")
                }
            },
        },

        // computed: {
        //   myState() {
        //     return this.$store.state.categories;
        //   },
        // },

        watch: {
          myState(newValue, oldValue) {
            // Do something with the new value of my_state
            // console.log(`my_state changed from ${oldValue} to ${newValue}`);
            // console.log(`my_state changed`);
            this.$store.state.sum_fact = ""
            this.$store.state.sum_plan = ""
            // this.fetchPosts_test_claster_stroki();
            // this.$store.state.metric_filtr = [];
            // this.fetchPosts_test_claster_block();
          },
        },

        computed: {
          dynamicPort() {
          const year = this.$store.state.year_change;
          
          if (year === 2025) {
            return "/api/dashboard";
          } else if (year === 2026) {
            return "/api/dashboard";
          } else {
            return "/api/dashboard";
          }
        },

          dynamicPort_PDF() {
            if (year === 2025) {
            return "/api/pdf";
          } else if (year === 2026) {
            return "/api/pdf";
          } else {
            return "/api/pdf";
          }

          },

          dynamicPort_Adminka() {
          const year = this.$store.state.year_change;
          
          if (year === 2025) {
            return "/api/admin";
          } else if (year === 2026) {
            return "/api/admin";
          } else {
            return "/api/admin";
          }
        }
      },

        //  computed: {
        //   dynamicPort() {
        //   const year = this.$store.state.year_change;
          
        //   if (year === 2025) {
        //     return "http://127.0.0.1:5000";
        //   } else if (year === 2026) {
        //     return "http://127.0.0.1:5000";
        //   } else {
        //     return "/api/dashboard";
        //   }
        // },

        //   dynamicPort_PDF() {
        //     return this.$store.state.year_change === 2025
        //       ? "http://adamserver.space:41433"
        //       : "http://adamserver.space:41433";
        //   }
        // },
       

        mounted() {
            this.fetchPosts_date_loader();
            this.fetchPosts_test_claster();
            this.fetchPosts_test_claster_stroki();
            this.fetchPosts_test_claster_block();
            this.fetchPosts_data_pokazatel_otstavania();
            this.fetchPosts_date_ur_lichza();

            // Добавьте вызов проверки при монтировании
            this.checkScreenSize();
            window.addEventListener('resize', this.checkScreenSize);
            this.fetchPosts_dinamic_claster();
            // this.fetchPosts_metrics_filtred();
            // this.fetchPosts_filtr_claster();
            // this.fetchPosts_count_sum();
            
            // this.focusInput()
        },
        beforeDestroy() {
          // Не забудьте удалить обработчик
          window.removeEventListener('resize', this.checkScreenSize);
        },
        disableBodyScroll() {
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
          // Сохраняем позицию скролла
          this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        },
        
        enableBodyScroll() {
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.width = '';
          // Восстанавливаем позицию скролла
          window.scrollTo(0, this.scrollPosition);
        },
        // computed: {
        //     groupedData() {
        //       const result = [];
        //       this.$store.state.categories.forEach(catg => {
        //         const claster = this.data_claster.find(cl => cl.name === catg);
        //         if (claster) {
        //           const blocks = this.post_block.filter(bl => bl.claster_id === claster.id);
        //           blocks.forEach(bl => {
        //             const metrics = this.$store.state.metric_filtr.filter(
        //               arr_m_f => arr_m_f.claster === claster.name && arr_m_f.block_id === bl.id
        //             );
        //             if (metrics.length > 0) {
        //               result.push({
        //                 claster: claster.name,
        //                 block: bl.name,
        //                 metrics: metrics,
        //               });
        //             }
        //           });
        //         }
        //       });
        //       return result;
        //     },
        //   },

        

    }
</script>
 
<style scoped>
/* мобилка */
@media (min-width: 0px) and (max-width: 430px) {


.icon_size_not {
	width: 19px;
	height: 19px;
  padding-right: 5px;
  margin-bottom: -2px;
  
}

   .item_test_nof_text_icon{
	display: grid;
	justify-content: left;
	align-items: center;
	color: white;
  margin: 0px;
  padding: 0px;
  }

   .item_test_nof_2_stroke{
	display: grid;
	justify-content: left;
	align-items: center;
	color: white;
  margin-top: -35px;
  padding: 0px;
  }

  .icon_text_nof {
    /* margin-left: -110px; */
    font-size: 22px;
  }


  .item_test_icon{
	grid-template-columns: 1fr;
	grid-template-rows: 1fr;
	display: grid;
	/* grid-auto-columns: minmax(50px, 6000px); */
	justify-content: center;
	align-items: center;
	margin-top: -5px;
	padding: 0px;
}


  .close:hover {
  color: #666;
}

/* Анимации при открытии */
.modal-enter-active .modal-content,
.modal-enter-to .modal-content {
  transform: scale(1) translateY(0);
  opacity: 1;
}

.modal-enter-active,
.modal-enter-to {
  opacity: 1;
}

/* Анимации при закрытии */
.modal-leave-active {
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-leave-active .modal-content {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-leave-to {
  opacity: 0;
}

.modal-leave-to .modal-content {
  transform: scale(0.98) translateY(5px);
  opacity: 0;
}

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6); /* Уменьшили прозрачность с 0.5 до 0.3 */
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background: #911313; /* Заменили белый цвет на красный (#ff0000) */
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 5px;
    color: white; /* Изменили цвет текста на белый для лучшей читаемости на красном фоне */
    
}

.close {
    color: #fff; /* Изменили цвет крестика на белый */
    float: right;
    font-size: 28px;
    cursor: pointer;
}




  .icon_size_notification {
	width: 30px;
	height: 30px;
  }


  .item_test_metrica {
	display: grid;
	align-items: center;
	justify-content: center;
	/* grid-template-rows: 1fr;  */
  }


  .container_grid_clasters_in_1{
	grid-template-columns: 1fr 4fr 1.5fr;
	display: grid;
	grid-auto-rows: minmax(120px, auto);
	align-items: center;
	grid-auto-flow: column;
	/* justify-content: start; */
	/* column-gap: 20px; */
	/* margin:0;
	padding:0; */
  margin: 0px;
  padding-bottom: 10px;
  }


  .item_test_metrica_two {
	display: grid;
	align-items: start;
	justify-content: start;
  }


  .container_test_grid {
	grid-template-columns: 6fr 3fr ;
	display: grid;
	align-items: center;
	justify-content: start;
	column-gap: 15px;
  margin-bottom: 10px;
	
  }

  .item_test_b_year{
	padding:5px;
	/* border: 1px solid white;*/
	color: white; 
  margin-top: 0;
  padding: 1px;
  }
  

  .otstup_up_to_clasters {
	margin-top: 16px;
  }

  .button_back_wc {
	width: 150px;
	height: 40px;
  }

  .circle_diogram {
	margin-top: -45px;
  margin: 0px;
  }

  .diogram_fact_plan {
	margin-top: -15px;
  text-align: left;
  }


  .container_test_grid_block_in {
	/* grid-template-columns: 1fr 1fr 1fr; */
	/* grid-template-rows: 1fr 3fr; */
	display: grid;
	/* column-gap: 20px; */
	align-items: start;
	
	/* grid-auto-rows: minmax(100px, auto); */
	/* margin:0;
	padding:0; */ 
  }

  .container_test_grid_block {
	grid-template-columns: 3fr 3fr 1fr;
	/* grid-template-rows: min; */
	grid-template-rows: max-content;
	display: grid;
	column-gap: 4px;
	/* grid-auto-flow: row; */
	
	
	/* align-items: start; */
	/* margin:0;
	padding:0; */
  }

   .text_size_input {
    font-size: 6px;
    padding: 0;
    margin: 0;
   }


  .icon_size {
    width: 10px;
    height: 10px;
  }

  .text_size_header_text_ed_izmer {
	  font-size: 10px;
    
  }

  .name_blocks {
    font-size: 14px;
  }

  .noficashion_text{
	  font-size: 14px;
  }
  .item_test_claster_block_left_percent {
	  font-size: 14px;
  }

  .item_test_claster_block_left_name {
    color: white;
    font-size: 14px;
  }

  .name_year {
    font-size: 9px;
  }

  .text_size_header_text_ed_izmer_razdel_fact {
	  font-size: 14px;
  }

  .name_razdel {
	  font-size: 9px;
  }

  .text_size_header_text_ed_izmer_razdel {
	  font-size: 7px;
  }

  .dinamica_claster {
	font-size: 10px;
	padding: 3px;
  margin: -35px 3px 0px 3px;
	border-radius: 2px;
	width: auto;
	height: auto;  
    
	
  }

  .otstup {
	margin-left: 10px;
	margin-right: 10px;
  }


  .otstup_mini {
    margin-top: -10px;
  }

  .otsup_mimi_up_block {
    margin-top: 5px;
  }

 

  .container_grid_clasters_in_2{
  display: grid;
	grid-auto-rows: minmax(100px, auto);
	justify-content: center;
	align-items: center;
	grid-auto-flow: column;
  }

  .container_grid_clasters_in_3{
	grid-template-columns: 1fr 3fr 2fr;
	display: grid;
	grid-auto-rows: minmax(100px, auto);
  }


  .item_test_colonka {
	display: grid;
	/* grid-template-rows: 1fr 1fr ; */
	justify-content: start;
	color: white;
	grid-auto-columns: minmax(150px, 300px);
  
  }


  .razdel_fact {
    display: grid;
    margin-left: 20px;
    font-size: 11px;
    justify-content: start;
    margin-top: -15px
  }

  .otstup_razdel {
    margin-top: -10px;
  }


  .text_size_header_text {
	  font-size: 16px;
	  /* font-weight: 900; */
	  font-style: normal;
	  line-height: 15px;
	  /* font-family: Arial; */
	  margin: 0%;
	  padding: 0%;
  }

 





  


}
/* планшет */
@media (min-width: 430px) and (max-width: 1300px) {
	/* html{ 
		font-size: 8px;
	} */





  .item_test_logo_col{
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: 1fr;
	display: grid;
	/* grid-auto-columns: minmax(50px, 6000px); */
	justify-content: center;
	align-items: center;
	margin: 0px;
	padding: 0px;
}


.container_grid_inputs{
	grid-template-columns: 1fr 1fr 1fr;
	display: grid;
	column-gap: 8px;
	
	/* margin:0;
	padding:0; */
  }



.container_test_grid {
	grid-template-columns: 4fr 3fr 0.5fr;
	display: grid;
	align-items: center;
	justify-content: start;
	/* column-gap: 15px; */
	margin-left: 0px;
	margin-right: 0px;
	padding-left: 0px;
	padding-right: 0px;
	
  }

  .container_grid_inputs_input{
	grid-template-columns: 3fr 1fr;
	display: grid;
	/* margin:0px 20px 0px 0px; */
	/* padding: 7px; */
	align-items: center;
	/* justify-content: start; */
	/* margin:0;
	padding:0; */
  }

  .text_size_input_b_year_choused {
	font-size: 7px;
	color: #fff;
  }

  .text_size_input_b_year {
	font-size: 7px;
	color: #606061;
  }


  .otstup_up_to_clasters {
	margin-top: 16px;
  }

  .button_back_wc {
	width: auto;
	height: 44px;
	margin-left: 10px;
	margin-right: 10px;
  }


  .container_test_grid_block_in {
	/* grid-template-columns: 1fr 1fr 1fr; */
	/* grid-template-rows: 1fr 3fr; */
	display: grid;
	/* column-gap: 20px; */
	align-items: start;
	
	/* grid-auto-rows: minmax(100px, auto); */
	/* margin:0;
	padding:0; */ 
  }


  .item_test_b_year{
	padding: 6px;
  
	/* border: 1px solid white;*/
	color: white; 
  }

  .container_test_grid_block {
	grid-template-columns: 3fr 3fr 1fr;
	/* grid-template-rows: min; */
	grid-template-rows: max-content;
	display: grid;
	column-gap: 4px;
	/* grid-auto-flow: row; */
	
	
	/* align-items: start; */
	/* margin:0;
	padding:0; */
  }

   .text_size_input {
    font-size: 6px;
    padding: 0;
    margin: 0;
   }


  .icon_size {
    width: 10px;
    height: 10px;
  }

  .text_size_header_text_ed_izmer {
	  font-size: 10px;
    
  }

  .name_blocks {
    font-size: 11px;
  }

  .noficashion_text{
	  font-size: 9px;
  }
  .item_test_claster_block_left_percent {
	  font-size: 11px;
  }

  .item_test_claster_block_left_name {
    color: white;
    font-size: 12px;
  }

  .name_year {
    font-size: 9px;
  }

  .text_size_header_text_ed_izmer_razdel_fact {
	  font-size: 10px;
  }

  .name_razdel {
	  font-size: 9px;
  }

  .text_size_header_text_ed_izmer_razdel {
	  font-size: 7px;
  }

  

  .otstup {
	margin-left: 10px;
	margin-right: 10px;
  }


  .otstup_mini {
    margin-top: -10px;
  }

  .otsup_mimi_up_block {
    margin-top: 5px;
  }

  .container_grid_clasters_in_1{
	grid-template-columns: 1fr 3fr 2fr;
	display: grid;
	grid-auto-rows: minmax(100px, auto);
  }

  .container_grid_clasters_in_2{
  display: grid;
	grid-auto-rows: minmax(100px, auto);
	justify-content: center;
	align-items: center;
	grid-auto-flow: column;
  }

  .container_grid_clasters_in_3{
	grid-template-columns: 1fr 3fr 2fr;
	display: grid;
	grid-auto-rows: minmax(100px, auto);
  }


  .item_test_colonka {
	display: grid;
	/* grid-template-rows: 1fr 1fr ; */
	justify-content: start;
	color: white;
	grid-auto-columns: minmax(150px, 300px);
  
  }


  .razdel_fact {
    display: grid;
    margin-left: 20px;
    font-size: 11px;
    justify-content: start;
    margin-top: -15px
  }

  .otstup_razdel {
    margin-top: -10px;
  }
  
}




 .loading_overlay {
	display: grid;
	place-items: center; /* одновременно выравнивает по горизонтали и вертикали */
	grid-template-rows: auto auto; /* две строки: для спиннера и текста */
	gap: 10px; /* отступ между элементами */
	
  }
  
  .spinner {
	border: 4px solid #f3f3f3;
	border-top: 4px solid #393838;
	border-radius: 50%;
	/* width: 20px;
	height: 20px; */
	animation: spin 2s linear infinite;
	/* margin-bottom: 10px; */
  margin: 0;
  padding: 0;
  }


/* .spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 2s linear infinite;
} */

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  color: red;
  margin-top: 10px;
}

.success-message {
  color: green;
  margin-top: 10px;
}

.dropdown {
 position: relative;
 display: inline-block;
 }

.dropdown-content {
 display: none;
 position: absolute;
 background-color: #1C1C1E;
 min-width: 100px;
 box-shadow: 0px 8px 8px 8px rgba(0,0,0,0.2);
 padding: 7px 17px;
 z-index: 1;
 border-radius: 7px;
 margin-top: 5px;
 }

.dropdown:hover.dropdown-content {
 display: block;
 }

.dropdown-content a {
 color: black;
 padding: 0px 0px;
 text-decoration: none;
 display: block;
 }

.dropdown-content a:hover {
 background-color: #f1f1f1;
 }


.disabled-button {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none; /* Блокирует все события мыши */
}
 











	

</style>



